import styled from '@emotion/styled';

import { formatGenericDate, formatCurrency, displayTruncated, formatGenericTime, formatPhoneNumber, formatGenericDateTime } from '../../util';

import BooleanChip from '../BooleanChip';

const CardBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.$gap || "1.5rem"};
`;

const CardInfoRow = styled.div`
  display: flex;
  align-items: ${props => props.$align || "center"};
  gap: 1.5rem;
`;

const CardInfoHeaderBlock = styled.div`
  display: flex;
  font-weight: 500;
  gap: .8rem;
  min-width: ${props => props.$spread ? props.$spread : "12rem"};
`;

const CardInfoBlock = styled.div`
  font-weight: ${props => ["currency", "percentage"].includes(props.$dataType) ? "500" : "normal"};
  flex-grow: ${props => props.$grow ? "1" : "0"};
  text-align: ${props => props.$grow ? "right" : "left"};
`;


const CardBlockHeader = styled.div`
  font-weight: 500;
  text-transform: uppercase;
  color: ${props => props.theme.colors.lightText};
  font-size: 1.2rem;
  /* margin-bottom: 1rem; */
`;

const CardSpacer = styled.div`
  margin-bottom: ${props => props.$spacing ? props.$spacing : props.theme.spacing(1)};
`;

const CardBlock = ({ header, info, icon, dataType = "text", booleanValues, showField, align = "center", spread = "12rem", isLast, grow }) => {
  if (showField && !showField()) return null;
  let value;
  switch (dataType) {
    case "date":
      value = formatGenericDate(info, "long");
      break;
    case "shortDate":
      value = formatGenericDate(info);
      break;
    case "dateTime":
      value = formatGenericDateTime(info);
      break;
    case "time":
      value = formatGenericTime(info);
      break;
    case "currency":
      value = formatCurrency(info);
      break;
    case "percentage":
      value = `${info}%`;
      break;
    case "phone":
      value = formatPhoneNumber(info);
      break;
    case "boolean":
      value = <BooleanChip check={info} values={booleanValues} />;
      break;
    default:
      value = info;
      break;
  }
  return (
    <CardInfoRow $align={align}>
      <CardInfoHeaderBlock $spread={spread}>
        {icon}
        {header}
      </CardInfoHeaderBlock>
      <CardInfoBlock $dataType={dataType} $grow={grow}>
        {value}
      </CardInfoBlock>
    </CardInfoRow>
  )
}

export { CardBlockContainer, CardInfoRow, CardInfoHeaderBlock, CardInfoBlock, CardBlock, CardBlockHeader, CardSpacer };